import { render } from "./ProductUpgrade.vue?vue&type=template&id=276979dd"
import script from "./ProductUpgrade.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductUpgrade.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ProductUpgrade.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "276979dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('276979dd', __exports__)) {
    api.reload('276979dd', __exports__)
  }
  
  module.hot.accept("./ProductUpgrade.vue?vue&type=template&id=276979dd", () => {
    api.rerender('276979dd', render)
  })

}


export default __exports__